/* ============================================================
   WATERSHED — Badge nativo do tema → rola até as reviews Judge.me
   ------------------------------------------------------------
   Arquivo 100% NOVO (não altera arquivos originais do tema).
   Carregado em layout/theme.liquid via:
     {{ 'badge-review.js' | asset_url | script_tag }}

   Para reverter numa atualização do tema:
     apague essa linha em theme.liquid + apague este arquivo.

   IMPORTANTE: este arquivo contém APENAS JavaScript.
   NÃO inclua tags <script> aqui — o filtro script_tag já as gera.
   (Era esse o bug da versão anterior: o navegador tentava
    interpretar "<script>" como JavaScript e quebrava tudo.)
   ============================================================ */

(function () {
  'use strict';

  function scrollToReviews() {
    var target =
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('.jm-review-widget') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.querySelector('[id*="judgeme"]');

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* Delegação no document: funciona mesmo que o badge do tema
     seja re-renderizado depois do carregamento da página. */
  document.addEventListener('click', function (e) {
    var badge = e.target.closest('.rating-badge');
    if (badge) {
      e.preventDefault();
      scrollToReviews();
    }
  });

  /* Cursor pointer no badge (reforço — o CSS também cobre isso). */
  function markPointer() {
    document.querySelectorAll('.rating-badge').forEach(function (el) {
      el.style.cursor = 'pointer';
    });
  }

  if (document.readyState !== 'loading') {
    markPointer();
  } else {
    document.addEventListener('DOMContentLoaded', markPointer);
  }
})();